var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBeansIcon = function SvgBeansIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.86,
    y: 0.173,
    width: 25.317,
    height: 26.106,
    rx: 12.659,
    fill: "#00546F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.812 15.352c-.7 1.74-1.703 3.065-2.949 3.77-1.216.687-2.769.845-4.734.056-1.966-.79-2.979-1.978-3.381-3.316-.413-1.37-.22-3.02.479-4.762.699-1.741 1.702-3.065 2.948-3.77 1.216-.688 2.769-.846 4.735-.056 1.786.718 2.815 1.902 3.261 3.28.453 1.4.33 3.083-.36 4.798Z",
    stroke: "#fff",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.526 7.715c0 .122-.036 3.648-2.843 5.137-2.78 1.473-3.427 2.923-3.541 5.76",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
};
export default SvgBeansIcon;